import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email.trim()) {
      setMessage("Inserisci la tua email.");
      return;
    }

    setSending(true);
    try {
      const res = await fetch(`${API_URL}/api/password-reset/request/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email: email.trim() }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.detail || "Errore richiesta.");

      setMessage("Se l’email è corretta, riceverai a breve un link per reimpostare la password.");
    } catch (err) {
      setMessage(err.message || "Errore imprevisto.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ maxWidth: 420, margin: "80px auto" }}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="mb-3 text-center">Recupera password</h4>

          {message && <div className="alert alert-info">{message}</div>}

          <form onSubmit={submit}>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="es. nome@email.it"
              />
            </div>

            <button className="btn btn-primary w-100" disabled={sending}>
              {sending ? "Invio..." : "Invia link di recupero"}
            </button>
          </form>

          <div className="text-center mt-3">
            <button className="btn btn-link" onClick={() => navigate("/login")}>
              Torna al login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
